import { useMotionPreference } from './useMotionPreference';

/**
 * True when motion should be suppressed — either because the OS asks for it or
 * because the visitor used the site's own control (WCAG 2.2.2).
 *
 * Thin wrapper over useMotionPreference so there is one source of truth; consumers
 * that only need to read the value do not have to destructure the setter.
 */
export function usePrefersReducedMotion(): boolean {
  return useMotionPreference().reduced;
}

export default usePrefersReducedMotion;
